var Vendd = (function (Vendd) {
    'use strict';

    Vendd.Store = (function (Store) {

        Store.Messages = (function (Messages) {

        Messages.BindControl = function (context) {
            var data = {
                context: context
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.BindControl', data);
        };
        Messages.BindControl.className = 'Vendd.Store.Messages.BindControl';

        Messages.SetContinent = function (continent) {
            var data = {
                continent: continent
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetContinent', data);
        };
        Messages.SetContinent.className = 'Vendd.Store.Messages.SetContinent';

        Messages.SetCountry = function (country) {
            var data = {
                country: country
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetCountry', data);
        };
        Messages.SetCountry.className = 'Vendd.Store.Messages.SetCountry';

        Messages.SetArea = function (area) {
            var data = {
                area: area
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetArea', data);
        };
        Messages.SetArea.className = 'Vendd.Store.Messages.SetArea';

        Messages.SetCity = function (city) {
            var data = {
                city: city
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetCity', data);
        };
        Messages.SetCity.className = 'Vendd.Store.Messages.SetCity';

        Messages.SetType = function (type) {
            var data = {
                type: type
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetType', data);
        };
        Messages.SetType.className = 'Vendd.Store.Messages.SetType';

        Messages.SetPostalCode = function (postalCode) {
            var data = {
                postalCode: postalCode
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.SetPostalCode', data);
        };
        Messages.SetPostalCode.className = 'Vendd.Store.Messages.SetPostalCode';

        Messages.Refine = function (data) {
            var data = {
                state: data
            };

            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.Refine', data);
        };
        Messages.Refine.className = 'Vendd.Store.Messages.Refine';


        Messages.UpdateForm = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.UpdateForm', data);
        };
        Messages.UpdateForm.className = 'Vendd.Store.Messages.UpdateForm';

        Messages.UpdateStores = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.UpdateStores', data);
        };
		Messages.UpdateStores.className = 'Vendd.Store.Messages.UpdateStores';

        Messages.CalculateDistances = function (array, source) {
        	var data = {
        		array: array,
				source: source
        	};
        	Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.CalculateDistances', data);
        };
        Messages.CalculateDistances.className = 'Vendd.Store.Messages.CalculateDistances';

        Messages.CalculateDistancesSuccess = function (data) {
        	
        	Vendd.MessageBus.VenddMessage.call(this, 'Vendd.Store.Messages.CalculateDistancesSuccess', data);
        };
        Messages.CalculateDistancesSuccess.className = 'Vendd.Store.Messages.CalculateDistancesSuccess';

        return Messages;

    })(Store.Messages || {});

        return Store;

    })(Vendd.Store || {});

return Vendd;

})(Vendd || {});